import { connect } from "formik";

import BrokerInviteForm from "./BrokerInviteForm";

export default connect(BrokerInviteForm);
